import { render, staticRenderFns } from "./TheBuildingList.vue?vue&type=template&id=d8f7c862&"
import script from "./TheBuildingList.vue?vue&type=script&lang=js&"
export * from "./TheBuildingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports